import { useEffect, useState } from "react";
const getMatches = (query) => {
    if (typeof window === "undefined") {
        return false;
    }
    return window.matchMedia(query).matches;
};
const useMediaQuery = (query) => {
    const [matches, setMatches] = useState(getMatches(query));
    useEffect(() => {
        if (typeof window === "undefined") {
            return undefined;
        }
        const mediaQuery = window.matchMedia(query);
        const update = () => setMatches(mediaQuery.matches);
        update();
        if (mediaQuery.addEventListener) {
            mediaQuery.addEventListener("change", update);
            return () => mediaQuery.removeEventListener("change", update);
        }
        // Fallback for environments without MediaQueryList.addEventListener:
        // listen for window resize and recompute the query match.
        const updateOnResize = () => setMatches(window.matchMedia(query).matches);
        window.addEventListener("resize", updateOnResize);
        return () => window.removeEventListener("resize", updateOnResize);
    }, [query]);
    return matches;
};
export default useMediaQuery;
